"use client";

import React from "react";

const variantColors = {
  primary: "border-lightCyan",
  secondary: "border-darkGrey",
  success: "border-statusSucces",
  danger: "border-statusDanger",
  warning: "border-statusWarning",
  info: "border-statusInfo",
  light: "border-lightGrey2",
  dark: "border-darkBlack",
};

const sizeStyles = {
  sm: "w-4 h-4 border-2",
};

/**
 * Spinner - Loading indicator.
 *
 * @param {string} animation - 'border' | 'grow' (both render a spinning circle)
 * @param {string} variant - 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'
 * @param {string} size - 'sm' for small
 */
export function Spinner({
  animation: _animation = "border",
  variant = "primary",
  size,
  className = "",
  children,
  style,
  ...props
}) {
  const colorClass = variantColors[variant] ?? variantColors.primary;
  const sizeClass = sizeStyles[size] || "w-8 h-8 border-[3px]";

  return (
    <div
      role="status"
      className={`inline-block rounded-full border-transparent animate-spin ${colorClass} ${sizeClass} ${className}`.trim()}
      style={{
        borderTopColor: "currentColor",
        borderRightColor: "currentColor",
        borderStyle: "solid",
        ...style,
      }}
      {...props}
    >
      {children || <span className="sr-only">Loading...</span>}
    </div>
  );
}

export default Spinner;
